import "./UserMenu.scss";
import { Modal } from "@mui/material";
import EditIcon from "@mui/icons-material/BorderColorOutlined";
import FavoriteIcon from "@mui/icons-material/FavoriteBorderOutlined";
import LoyaltyIcon from "@mui/icons-material/Loyalty";
import AddressIcon from "@mui/icons-material/PinDropOutlined";
import LogoutIcon from "@mui/icons-material/LogoutOutlined";
import { Link } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import { useLanguage } from "../../context/LanguageContext";

const UserMenu = ({ open, onClose, onLogout }) => {
  const { logout } = useAuth();
  const { t } = useLanguage();

  const handleLogout = async () => {
    // If onLogout prop is provided, use it; otherwise use the logout from context
    if (onLogout) {
      onLogout();
    } else {
      await logout();
    }
    onClose();
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="user-menu-modal"
      aria-describedby="user-menu-description"
      className="home-profile-modal"
    >
      <div className="profile-container">
        <Link className="link" to="/profile" onClick={onClose}>
          <EditIcon className="icon" />
          <span>{t("profile") || "الملف الشخصي"}</span>
        </Link>
        {/* <Link className="link" to="/subscriptions" onClick={onClose}>
          <LoyaltyIcon className="icon" />
          <span>{t("subscriptions") || "الاشتراكات"}</span>
        </Link> */}

        <Link className="link" to="/address" onClick={onClose}>
          <AddressIcon className="icon" />
          <span>{t("address") || "العنوان"}</span>
        </Link>
        <button className="link logout-button" onClick={handleLogout}>
          <LogoutIcon className="icon logout-icon" />
          <span>{t("logout") || "تسجيل الخروج"}</span>
        </button>
      </div>
    </Modal>
  );
};

export default UserMenu;
